'use client';

import { useQueryClient } from '@tanstack/react-query';
import { useSocket } from 'src/shared/hooks/useSocket';
import { useOrg } from 'src/shared/contexts/OrgContext';
import { getInternalNotesQueryKey } from 'src/shared/queries/internal-notes/useInternalNotes';

export function useInternalNotesSocket(integrationId?: string, threadId?: string) {
  const queryClient = useQueryClient();
  const { currentOrg } = useOrg();

  useSocket({
    roomId: integrationId && threadId ? ['thread', integrationId, threadId] : [],
    event: 'internal_notes',
    disabled: !integrationId || !threadId,
    callback: () => {
      if (integrationId && threadId) {
        queryClient.invalidateQueries({
          queryKey: getInternalNotesQueryKey(currentOrg.id, integrationId, threadId),
        });
      }
    },
  });
}
